export default "__VITE_ASSET__DiT$DQAN__"